export default __webpack_public_path__ + "static/media/purchase_account_arrow_up.75ad6202.svg";